"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainView = void 0;
const View_1 = require("../core/render/View");
const viewModelCollection_1 = require("../viewModelCollection");
const NavBarView_1 = require("./NavBarView");
const HomeView_1 = require("./HomeView");
const MusicView_1 = require("./MusicView");
const PlayerView_1 = require("./PlayerView");
const AddNewSongView_1 = require("./AddNewSongView");
const MusicDetailsView_1 = require("./MusicDetailsView");
const AboutView_1 = require("./AboutView");
class MainView extends View_1.View {
    constructor() {
        super();
        this.navigationView = new NavBarView_1.NavBarView();
        this.bodyWidget = new HomeView_1.HomeView();
        this.playerWidget = new PlayerView_1.PlayerView();
        this.afterConstruction = this.afterConstructionFunction;
        this.dataContext = viewModelCollection_1.getMainViewModel();
    }
    afterConstructionFunction() {
        this.navigationView.parentWidget = this;
        this.navigationView.renderOnce = true;
        this.navigationView.navItemClicked = (name) => {
            this.navigate(name, null);
        };
        this.navigationView.addNavLink("Home");
        this.navigationView.addNavLink("Music");
        this.navigationView.addNavLink("About");
        this.dataContext.logger.logDebug("[Main View]: Added navigation links.");
        this.bodyWidget.parentWidget = this;
        this.playerWidget.renderOnce = true;
        this.playerWidget.parentWidget = this;
        this.dataContext.logger.logDebug("[Main View]: Widgets added");
        this.widgets.push(this.navigationView);
        this.widgets.push(this.bodyWidget);
        this.widgets.push(this.playerWidget);
    }
    navigate(viewToSwitch, args) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (viewToSwitch) {
                case "Home":
                    this.bodyWidget = new HomeView_1.HomeView();
                    this.bodyWidget.parentWidget = this;
                    this.widgets[1] = this.bodyWidget;
                    this.clear();
                    yield this.render();
                    break;
                case "Music":
                    this.dataContext.logger.logDebug("[Main View]: Music navigation link clicked.");
                    this.bodyWidget = new MusicView_1.MusicView(this);
                    this.widgets[1] = this.bodyWidget;
                    this.bodyWidget.parentWidget = this;
                    this.clear();
                    yield this.render();
                    break;
                case "AddNewSong":
                    this.dataContext.logger.logDebug("[Main View]: Add new song view requested.");
                    this.bodyWidget = new AddNewSongView_1.AddNewSongView(this);
                    this.bodyWidget.parentWidget = this;
                    this.widgets[1] = this.bodyWidget;
                    this.clear();
                    yield this.render();
                    break;
                case "MusicDetails":
                    this.dataContext.logger.logDebug(`[Main View]: Music details for songId '${args.songId}' requested.`);
                    this.bodyWidget = new MusicDetailsView_1.MusicDetailsView(args.songId, this);
                    this.bodyWidget.parentWidget = this;
                    this.widgets[1] = this.bodyWidget;
                    this.clear();
                    yield this.render();
                    break;
                case "About":
                    this.dataContext.logger.logDebug(`[Main View]: About view requested.`);
                    this.bodyWidget = new AboutView_1.AboutView();
                    this.bodyWidget.parentWidget = this;
                    this.widgets[1] = this.bodyWidget;
                    this.clear();
                    yield this.render();
                    break;
            }
        });
    }
    render() {
        const _super = Object.create(null, {
            render: { get: () => super.render }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.dataContext.logger.logDebug("[Main View]: Rendering main view...");
            yield _super.render.call(this);
        });
    }
    shouldRender() {
        return true;
    }
}
exports.MainView = MainView;
//# sourceMappingURL=MainView.js.map